/**
 * 我的学籍
 */

import request from "@/utils/request";

// 获取学籍信息
export async function getStudentAccount(data) {
  return request.get("/studentAccount/getStudentAccount", data);
}

// 修改信息
export async function updateStudentAccount(data) {
  return request.post("/studentAccount/updateStudentAccount", data);
}

// 查询用户个人信息
export async function getUserAccount() {
  return request.get("/user");
}
